import { StateCreator } from 'zustand';
import type { DetailsRequest, DetailsProductsRequest, DetailsSourceRequest } from '../types';

export type RequestState = {
  omnichannelRequestBody: DetailsRequest;
  detailingChainsData: any;
  detailingProductsData: any;
  omnichannelDetailsProductsBodyRequest: DetailsProductsRequest;
  omnichannelDetailsProductsTableData: any;
  omnichannelSourcesBodyRequest: DetailsSourceRequest;
};

export type RequestActions = {
  setOmnichannelMutateRequestBody: (name: string, data: any) => void;
  resetRequestBody: () => void;
  resetOmnichannelSourcesBodyRequest: () => void;
};

const defaultRequestBody = {
  redes: [] as string[],
  semanas: 12,
  ufs: ['TODO_TERRITORIO'] as string[],
  cidades: [] as string[],
  gtins: [] as string[],
  tipoPreco: 'PRECO_PAGO' as string,
};

export const requestInitialState: RequestState = {
  detailingChainsData: [],
  detailingProductsData: [],
  omnichannelRequestBody: {
    ...defaultRequestBody,
  },
  omnichannelDetailsProductsBodyRequest: {
    params: {
      sort: 'PRECO_SITES_PROPRIOS',
      direction: 'ASC',
    },
    body: {
      ...defaultRequestBody,
      page: 0,
      size: 10,
      query: [],
    },
  },
  omnichannelDetailsProductsTableData: [],
  omnichannelSourcesBodyRequest: {
    ...defaultRequestBody,
    page: 0,
    size: 10,
    sortBy: '',
    sortDirection: '',
  },
};

type RequestSlice = RequestState & RequestActions;

export const createRequestSlice: StateCreator<RequestSlice> = set => ({
  ...requestInitialState,
  setOmnichannelMutateRequestBody: (name: string, data: any) => {
    set(state => ({ omnichannelRequestBody: { ...state.omnichannelRequestBody, [name]: data } }));
  },
  resetRequestBody: () => {
    set({
      omnichannelRequestBody: { ...defaultRequestBody },
      productFilterType: 'TODOS',
      localFilterType: 'TODO_TERRITORIO',
    } as any);
  },
  resetOmnichannelSourcesBodyRequest: () => {
    set({
      omnichannelSourcesBodyRequest: {
        ...defaultRequestBody,
        page: 0,
        size: 10,
        sortBy: '',
        sortDirection: '',
      },
    });
  },
});
